import { Height } from '@mui/icons-material';
import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Open Sans',
      'sans-serif',
    ].join(','),
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans, sans-serif',
          letterSpacing: '0.5px',
          textTransform: 'capitalize',
          fontWeight: '600',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans, sans-serif',
          letterSpacing: '0.5px',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans, sans-serif',
          color: "#4B5851",
          letterSpacing: '0.5px',
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans, sans-serif',
          fontSize: '0.9rem',
          color: "#4B5851",
          fontWeight: '600',
          letterSpacing: '0.5px',
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          fontFamily: 'Open Sans, sans-serif',
          fontSize: '0.9rem',
          margin: '0px',
          color: "#4B5851",
          "& > span": {
            fontSize: '0.9rem',
            letterSpacing: '0.5px',
            padding: 0,
          },
          "& > span:nth-child(2)": {
            paddingLeft: '10px',
          }
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          height: '48px',
          "& > .MuiInputBase-root": {
            height: '48px',
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          height: '48px',
          "& > .MuiInputBase-root": {
            height: '48px',
          }
        }
      }
    }
  },
  palette: {
    primary: {
      main: '#EF4642',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
